import React, { Component } from 'react';
import classNames from 'classnames';
import Link from 'react-router-dom/Link';

import './styles.css';

/**
 * A simple link with an arrow.
 *
 * @typedef {Object} Props
 * @prop {String} [className]
 * @prop {String} [href]
 * @prop {Function} [onClick]
 *
 * @augments {Component<Props>}
 */
export default class ArrowLink extends Component {
	genClassName = (props) => classNames('ArrowLink', props.className);

	handleClick = () => this.props.onClick && this.props.onClick();

	render () {
		const { href } = this.props;

		return href ? (
			<Link className={this.genClassName(this.props)} to={href}>
				<span>{this.props.children}</span>
			</Link>
		) : (
			<button
				className={this.genClassName(this.props)}
				onClick={this.handleClick}
			>
				<span>{this.props.children}</span>
			</button>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/atoms/ArrowLink/ArrowLink.js